<template>
  <div v-if="this.item.uptime?.timeline.length > 0">
    <span>
      {{ this.item.uptime.percent + '%' }}
    </span>
    <TimeProgressCard
      :status = "true"
      :info = "this.item.uptime?.timeline"
      :period = "this.translate('period')"
      :width = "this.parent_width"
    />
  </div>

  <span v-else>
    {{ date }}
  </span>
</template>


<script>
import TimeProgressCard from 'components/UIComponents/Charts/TimeProgressCard.vue'

export default {
  name: 'DeviceTimelineChart',
  components: {
    TimeProgressCard
  },
  props: ['type', 'item', 'chartStatus', 'trig_resize', 'parent_width'],

  computed:{
    date(){
      let tmpDate = new Date(this.item.uptime.offline * 1000)
      return this.item.uptime.offline === null ? this.translate('no_data') : this.translate('device.offline_from') + ' ' + tmpDate.toLocaleString()
    }
  }
}
</script>
